// Lightweight CLS telemetry for route-level monitoring.
export function initWebVitalsTelemetry() {
    if (window.__stackoraVitalsInit) return;
    window.__stackoraVitalsInit = true;

    if (typeof PerformanceObserver !== "function") return;

    var metricId = "cls-" + Date.now().toString(36) + "-" + Math.floor(Math.random() * 100000).toString(36);
    var metric = {
        name: "CLS",
        id: metricId,
        value: 0,
        delta: 0,
        rating: "good",
        path: window.location.pathname + window.location.search
    };

    var clsValue = 0;
    var sessionValue = 0;
    var sessionEntries = [];
    var flushed = false;

    function clsRating(value) {
        if (value > 0.25) return "poor";
        if (value > 0.1) return "needs-improvement";
        return "good";
    }

    function trackGA(name, params) {
        if (typeof window.gtag === "function") window.gtag("event", name, params || {});
    }

    function sendWebVital(payload) {
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) {
            var blob = new Blob([body], { type: "application/json" });
            if (navigator.sendBeacon("/telemetry/web-vitals", blob)) return;
        }

        fetch("/telemetry/web-vitals", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            keepalive: true,
            body: body
        }).catch(function () { });
    }

    function flush() {
        if (flushed || metric.value <= 0) return;
        flushed = true;

        sendWebVital(metric);
        trackGA("web_vital", {
            metric_name: metric.name,
            metric_id: metric.id,
            metric_value: Math.round(metric.value * 1000),
            metric_delta: Math.round(metric.delta * 1000),
            metric_rating: metric.rating,
            page_path: metric.path
        });
    }

    try {
        var observer = new PerformanceObserver(function (list) {
            list.getEntries().forEach(function (entry) {
                if (entry.hadRecentInput) return;

                if (
                    sessionEntries.length === 0 ||
                    entry.startTime - sessionEntries[sessionEntries.length - 1].startTime < 1000 &&
                    entry.startTime - sessionEntries[0].startTime < 5000
                ) {
                    sessionEntries.push(entry);
                    sessionValue += entry.value;
                } else {
                    sessionEntries = [entry];
                    sessionValue = entry.value;
                }

                if (sessionValue <= clsValue) return;

                metric.delta = sessionValue - clsValue;
                clsValue = sessionValue;
                metric.value = clsValue;
                metric.rating = clsRating(metric.value);
            });
        });

        observer.observe({ type: "layout-shift", buffered: true });
    } catch (_) {
        return;
    }

    window.addEventListener("pagehide", flush, { once: true });
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") flush();
    });
}
